export default "__VITE_ASSET__DaTxgOAw__"